define('sentient/aba/models/SessionModel',[
    'underscore',
    'backbone',
    'loglevel',
    'Backbone.localStorage',
    '../app'
], function(_, Backbone, log, localStorage, app) {

    var SessionModel = Backbone.Model.extend({
        defaults: {
            'exerciseId': 0,
            'paused': false,
            'pausable': false,
            'bucket-top': '',
            'bucket-bottom': '',
            'dialog': null,
            'exercisesCompleted': 0,
            'completedTaskCount': 0,
            'taskCount': -1,
            'accuracy': -1,
            'speed': -1,
            'minSa': -1,
            'maxSa': -1,
            'coundown': null,
            'task': null,
            'taskArrowsHintsRemaining': 3,
            //'previouslyDisplayedPrime':null,
            //'previouslyDisplayedTask':null,
            'sessionEndLayout': false,
            'speedLabel': '',
            'accuracyLabel': '',
            'maxSaLabel': '',
            'minSaLabel': '',
            'sessionEndMessage': '',
            'iconsVisible': true
        },
        initialize: function(options) {
            this.on({
                'sessionStart': this.handleSessionStart,
                'exerciseChange': this.handleExerciseChange,
                'exerciseCountDown': this.handleExerciseCountDown,
                'task': this.handleTask,
                'prime': this.handlePrime,
                'sessionEnd': this.handleSessionEnd,
                'pause': this.handleSessionPause,
                'unpause': this.handleSessionUnpause,
                'sessionEndMessage': null,
                '': null
            });
        },
        localStorage: new Backbone.LocalStorage('ABA-Session'),
        id: 0, //<-- set this to a constent so that local storage knows that his is a single model, not part of a collection.
        handleSessionStart: function(options) {
            //log.debug('Event: SessionStart', options);
            if (options && options.dialog) {
                this.set('dialog', {
                    'mode': 'acknowledgeToContinue',
                    'message': options.dialog
                });
            }
            this.set({
                'pausable': false,
                'paused': false,
                'accuracy': -1,
                'speed': -1,
                'countdown': null,
                'task': null,
                'prime': null,
                'speedLabel': null,
                'accuracyLabel': null,
                'sessionEndMessage': null
            });
        },
        handleExerciseChange: function(options) {
            setTimeout($.proxy(function() {
                var options = this.options;
                var model = this.model;
                //log.debug('Event: exerciseChange', this);
                if (options) {
                    if (options.exerciseId) {
                       //model.set('exerciseId', parseInt(options.exerciseId, 10));
       model.set('exerciseId', options.exerciseId);
             }
                    if (options.taskCount) {
                        model.set('taskCount', parseInt(options.taskCount, 10));
                    }
                    if (options.buckets) {
                        if (options.buckets.top) {
                            model.set('bucket-top', options.buckets.top);
                        }
                        if (options.buckets.bottom) {
                            model.set('bucket-bottom', options.buckets.bottom);
                        }
                    }
                    if (options && options.dialog) {
                        model.set('dialog', {
                            'mode': 'acknowledgeToContinue',
                            'message': options.dialog
                        });
                    }
                }
                //log.debug('old speed:',this.get('speed'));
                //model.set('accuracy', 0.5);

                if (options && options.initialAccuracyGaugeValue) {
                    model.set('accuracy', options.initialAccuracyGaugeValue);
                } else {
                    model.set('accuracy', 0.5);
                }

                if (options && options.initialSpeedGaugeValue) {
                    model.set('speed', options.initialSpeedGaugeValue);
                } else {
                    model.set('speed', 0.5);
                }




                model.set({
                    'completedTaskCount': 0
                });
                model.set({
                    'pausable': false,
                    'paused': false,
                    'countdown': null,
                    'task': null,
                    'prime': null,
                    'sessionEndLayout': false,
                    'speedLabel': null,
                    'accuracyLabel': null,
                    'sessionEndMessage': null
                });
            }, {
                model: this,
                options: options
            }), 1000);
        },
        handleExerciseCountDown: function(options) {
            //log.debug('Event: exerciseCountDown', options);
            this.set({
                'pausable': true,
                'dialog': null,
                'countdown': {
                    'message': options.dialog || 'Ready!',
                    'countdownStart': options.countdownStart || 3,
                    'countdownTime': options.countdownTime || 3000
                },
                'task': null,
                'prime': null,
                'sessionEndLayout': false
            });
        },
        handleTask: function(options) {
            //log.debug('Event: task', options);
            this.set({
                'dialog': null,
                'countdown': null,
                'task': options,
                'prime': null,
                'sessionEndLayout': false
            });
        },
        handlePrime: function(options) {
            //log.debug('Event: prime', options);
            var model = this;
            setTimeout(function() {
                model.set({
                    'dialog': null,
                    'countdown': null,
                    'task': null,
                    'sessionEndLayout': false,
                    'prime': options
                });
            }, 500);
        },
        handleSessionEnd: function(options) {
            //log.debug('Event: SessionEnd', options);
            var accuracy = 0;
            var speed = 0;
            var saMin = 0;
            var saMax = 0;
            if (app && app.sessionResultModel) {
                accuracy = app.sessionResultModel.averageExerciseAccuracy();
                speed = app.sessionResultModel.averageExerciseSpeed();

            }
            //console.log("accuracy",accuracy);
            //console.log("speed",speed);
            this.set({
                'pausable': false,
                'dialog': null,
                'countdown': null,
                'task': null,
                'prime': null,
                'bucket-top': '',
                'bucket-bottom': '',
                'taskCount': -1,
                'sessionEndLayout': true,
                'iconsVisible': options.iconsVisible,
                'accuracy': -1,
                'speed': -1,
                'saMin': -1,
                'saMax': -1
            });

            if (app.subconsciousAssociations) {
                var sa = app.sessionResultModel.subconsciousAssociations();
                if (sa && sa.min && sa.max) {
                    log.debug("subconsciousAssociations=", sa);
                    //        log.debug("app.primes=",app.primes);


                    saMin = sa.min.CDFIndexedValues;
                    saMax = sa.max.CDFIndexedValues;

                    var downBucket = _.findWhere(sa.buckets, {
                        orientation: "down"
                    });

                    options['StrongSALanguage'] = options['StrongSALanguage'].replace('#bucket', "'" + downBucket.id + "'");

                    var maxPrime = app.primes.findWhere({
                        'name': sa.max.id
                    });
                    log.debug("maxPrime=", maxPrime);
                    if (maxPrime && maxPrime.get('type') == 'image') {
                        var maxImgString = "<img class='sa-prime' src='" + maxPrime.get('source') + "' >";
                        options['StrongSALanguage'] = options['StrongSALanguage'].replace("#prime", maxImgString);
                        //options['StrongSALanguage'] = options['StrongSALanguage'].replace('#prime', sa.max.prime);
                    }
                    if (maxPrime && maxPrime.get('type') == 'text') {
                        options['StrongSALanguage'] = options['StrongSALanguage'].replace("#prime", maxPrime.get('source'));
                    }

                    options['WeakSALanguage'] = options['WeakSALanguage'].replace('#bucket', "'" + downBucket.id + "'");
                    var minPrime = app.primes.findWhere({
                        'name': sa.min.id
                    });
                    log.debug("minPrime=", minPrime);
                    if (minPrime && minPrime.get('type') == 'image') {
                        var minImgString = "<img class='sa-prime' src='" + minPrime.get('source') + "' >";
                        options['WeakSALanguage'] = options['WeakSALanguage'].replace("#prime", minImgString);
                        //options['WeakSALanguage'] = options['WeakSALanguage'].replace('#prime', sa.min.prime);
                    }
                    if (minPrime && minPrime.get('type') == 'text') {
                        options['WeakSALanguage'] = options['WeakSALanguage'].replace("#prime", minPrime.get('source'));
                    }


                    setTimeout($.proxy(function() {

                        this.sessionModel.set({
                            'saMin': 0,
                            'saMax': 0
                        });
                        //					console.log("this.sessionModel.set()");
                    }, {
                        'sessionModel': this,
                        'saMin': saMin,
                        'saMax': saMax
                    }), 100);

                    setTimeout($.proxy(function() {
                        this.sessionModel.set({
                            'saMin': this.saMin,
                            'saMax': this.saMax,
                            'minSaLabel': options['WeakSALanguage'],
                            'maxSaLabel': options['StrongSALanguage'],
                            //'minSaIcon': minImgString,
                            //'maxSaIcon': maxImgString,
                            'sessionEndMessage': options['SessionEndLanguage']
                        });
                    }, {
                        'sessionModel': this,
                        'saMin': saMin,
                        'saMax': saMax,
                        'options': options
                    }), 1000);


                }
            } else {
                setTimeout($.proxy(function() {
                    this.sessionModel.set({
                        'accuracy': 0,
                        'speed': 0
                    });
                }, {
                    'sessionModel': this,
                    'accuracy': accuracy,
                    'speed': speed
                }), 100);

                setTimeout($.proxy(function() {
                    this.sessionModel.set({
                        'averageAccuracy': this.accuracy,
                        'averageSpeed': this.speed,
                        'speedLabel': options['SpeedFeedbackLanguage'],
                        'accuracyLabel': options['AccuracyFeedbackLanguage'],
                        'sessionEndMessage': options['SessionEndLanguage']
                    });
                }, {
                    'sessionModel': this,
                    'accuracy': accuracy,
                    'speed': speed,
                    'options': options
                }), 1000);
            }

            if (app) {
                app.sessionResultModel.save();
            }
        },
        handleSessionPause: function() {
            this.set({
                'task': null,
                'prime': null,
                'countdown': null
            });
        },
        handleSessionUnpause: function() {

        }

    });

    return SessionModel;

});
